
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"33","height":"33"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(0 -.5)","clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M18.641 33V17.947h5.053l.756-5.866h-5.809V8.335c0-1.7.472-2.856 2.907-2.856h3.106V.231A41.634 41.634 0 0020.126 0c-4.479 0-7.545 2.734-7.545 7.754v4.326H7.517v5.866h5.066V33h6.058z","fill":"#3c5a9a"}})])])
          )
        }
      }
    